import { cursor } from '../utility/cursor.js'

const cursorEl = document.querySelector('#cursor')
const cursorCircleEl = cursorEl.querySelector('.cursor__circle')

const cursorEvents = cursor()
const speed = 0.1 // between 0 and 1
const lastPos = { x: -1, y: -1 }

cursorEvents.onUpdate(pos => {
	if (lastPos.x === -1) {
		lastPos.x = pos.easedX
		lastPos.y = pos.easedY
	}

	const diffX = Math.round(pos.x - lastPos.x)
	const diffY = Math.round(pos.y - lastPos.y)
	
	const angle = getAngle(diffX, diffY)
	const squeeze = getSqueeze(diffX, diffY)
	
	const scale = 'scale(' + (1 + squeeze) + ', ' + (1 - squeeze) +')'
	const rotate = 'rotate(' + angle +'deg)'
	const translate = 'translate3d(' + pos.easedX + 'px ,' + pos.easedY + 'px, 0)'

	cursorEl.style.transform = translate
	cursorCircleEl.style.transform = rotate + scale

	if (pos.percentX > 0.25) {
		cursorEl.classList.add('right')
	} else {
		cursorEl.classList.remove('right')
	}

	lastPos.x = pos.easedX
	lastPos.y = pos.easedY
})

function getAngle(diffX, diffY) {
  return Math.atan2(diffY, diffX) * 180 / Math.PI
}

function getSqueeze(diffX, diffY) {
  const distance = Math.sqrt(
    Math.pow(diffX, 2) + Math.pow(diffY, 2)
  )
  const maxSqueeze = 0.05
  const accelerator = 1500
  return Math.min(distance / accelerator, maxSqueeze)
}


const cursorModifiers = document.querySelectorAll('[cursor-class]')

cursorModifiers.forEach(cursorModifier => {
	var className = cursorModifier.getAttribute('cursor-class')
	var dataTitle = cursorModifier.getAttribute('data-title')

  cursorModifier.addEventListener('mouseenter', event => {
		cursorEl.classList.add(className, 'active')
		if (dataTitle) {
			cursorEl.setAttribute('data-title', dataTitle)
		}
	})
  
	cursorModifier.addEventListener('mouseleave', event => {
    if (className === 'link') {
      cursorEl.classList.remove(className, 'link')
    } else {
      cursorEl.classList.remove(className, 'active')
    }
  })
})